<template>
  <div v-for="(audit, index) in auditsData" v-bind:key="audit.cle" class="row ligne-audit-changement">
    <div class="col text-left">
      <div v-if="index === 0" class="row large-600 bold">Enregistrement courant</div>
      <div v-if="audit.modifieLe" class="row large-600 bold">Informations enregistrées le : {{ $commun.formatDateHeure(audit.modifieLe) }}</div>
      <div v-else class="row large-600 bold">Informations enregistrées le : {{ $commun.formatDateHeure(adressePrincipale.creerLe) }}</div>
      <div v-if="audit.changeParEntite" class="row large-600 bold">
        Par : {{ audit.changeParEntite.nomIntervenant?.trim() }}, {{ audit.changeParEntite.prenomIntervenant?.trim() }}, {{ audit.changeParEntite.nomGroupeSecurite?.trim() }}</div>
      <div v-else-if="adressePrincipale.creerParEntite" class="row large-600 erreur bold">
        Par : {{ adressePrincipale.creerParEntite.nomIntervenant?.trim() }}, {{ adressePrincipale.creerParEntite.prenomIntervenant?.trim() }}, {{ adressePrincipale.creerParEntite.nomGroupeSecurite?.trim() }}</div>
      <div v-else class="row large-600 erreur bold">
        Intervenant(e) inconnu(e)...</div>

      <div v-for="field in AUDIT_FIELDS" v-bind:key="field" class="row">
        <div class="col-5">{{ FIELD_LABELS[field] }} : </div>
        <div class="col text-center"><div v-if="audit[field].isModifie">{{ this.MODIFIED_ARROW }}</div></div>
        <div class="col">{{ audit[field].texte }}</div>
      </div>
    </div>
  </div>

  <h3>Nombre de modifications : {{ nombreModifications }}</h3>
</template>

<script>
import axios from "axios"
import { mapGetters } from "vuex"

export default {
  name: "TableModificationsTelephone",
  emits: ["isDataLoaded", "backendError"],
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle
    if(this.adressePrincipale) {
      this.$store
          .dispatch("adresse/obtenirAuditsAction", {
            cle: this.$route.params.cle,
            site: this.$route.params.site,
            genre: this.$root.$refs.breadcrumbComp.source.genre,
          })
          .then(res => {
            this.adressePrincipale.creerParEntite = res.data.entite.creerParEntite
            this.auditsData = res.data.entite.auditsTelephone
            if (this.auditsData !== null && this.auditsData.length > 0) {
              this.auditsData = this.formatterAudits(this.auditsData)
            } else {
              this.auditsData = this.formatterAucunAudit()
            }
          })
          .catch(err => {
            this.$emit("backendError", err)
            this.auditsData = this.formatterAucunAudit()
          })
          .finally(() => {
            this.$emit("isDataLoaded", true)
          })
    }
  },
  data() {
    return {
      auditsData: [],
      auditsDataAfficher: [],
      MODIFIED_ARROW: "🢂",
      AUDIT_FIELDS: [
        "telephone1",
        "typeTelephone1Afficher",
        "disponibilite1Afficher",
        "telephone2",
        "typeTelephone2Afficher",
        "disponibilite2Afficher",
        "telephone3",
        "typeTelephone3Afficher",
        "disponibilite3Afficher",
      ],
      FIELD_LABELS: {
        "disponibilite1Afficher": "Disponibilité 1",
        "disponibilite2Afficher": "Disponibilité 2",
        "disponibilite3Afficher": "Disponibilité 3",
        "telephone1": "Téléphone 1",
        "telephone2": "Téléphone 2",
        "telephone3": "Téléphone 3",
        "typeTelephone1Afficher": "Type Tel. 1",
        "typeTelephone2Afficher": "Type Tel. 2",
        "typeTelephone3Afficher": "Type Tel. 3",
      },
    };
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
      adressePrincipale: "adresse/adressePrincipale",
    }),
    nombreModifications() {
      if(this.auditsData.length > 0){
        return this.auditsData.length - 1;
      }else{
        return this.auditsData.length;
      }
    },
    createur() {
      return this.adressePrincipale.creerParDescription
    },
    dateCreation() {
      return this.adressePrincipale.creerLe
    },
  },
  methods: {
    formatterAudits(listeAudits) {
      let listeAffichage = []
      let auditPrecedent = null

      listeAudits.sort((a,b) => {
        return new Date(a.modifieLe) - new Date(b.modifieLe)
      });

      const dernierAudit = listeAudits[listeAudits.length - 1];

      // Par design, on veut afficher les infos actuelles dans le dernier enregistrement. On pousse donc
      // artificiellement un "audit" avec les téléphones actuels de l'adresse. Or, si un utilisateur modifie seulement
      // le code postal, par exemple, cela va créer un nouvel audit avec uniquement le code postal de modifié.
      // Cela signifie que les valeurs des téléphones du dernier audit de l'adresse ET de l'adresse actuelle sont
      // identiques. Dans ce cas, on ne veut pas insérer les valeurs actuelles, car sinon il y aura un doublon,
      // étant donné que les téléphones n'ont pas été modifiés. On insère donc les téléphones actuels seulement si les
      // téléphones ont été modifiés.
      if(this.haveTelephonesChanged(dernierAudit)) {
        listeAudits.push({
          "telephone1": this.adressePrincipale.telephone1,
          "typeTelephone1Afficher": this.adressePrincipale.typeTelephone1Afficher,
          "disponibilite1Afficher": this.adressePrincipale.disponibilite1Afficher,
          "telephone2": this.adressePrincipale.telephone2,
          "typeTelephone2Afficher": this.adressePrincipale.typeTelephone2Afficher,
          "disponibilite2Afficher": this.adressePrincipale.disponibilite2Afficher,
          "telephone3": this.adressePrincipale.telephone3,
          "typeTelephone3Afficher": this.adressePrincipale.typeTelephone3Afficher,
          "disponibilite3Afficher": this.adressePrincipale.disponibilite3Afficher,
        })
      }

      listeAudits.forEach((audit, index) => {
        let auditAffichage = {}
        this.AUDIT_FIELDS.forEach(field => {
          auditAffichage[field] = { texte: audit[field], isModifie: false, }

          if (auditPrecedent
              && auditPrecedent[field].texte !== auditAffichage[field].texte) {
            auditAffichage[field].isModifie = true
          }
        })

        // pour l'affichage, il faut comprendre que les entrées de la table
        // d'audits sauvegardent l'information de l'adresse _avant_ qu'il ne change.
        // autrement dit, puisqu'on commence avec creerParEntite, les informations suivantes
        // de l'adresse sont une date "en retard".
        auditAffichage.changeParEntite = index === 0
            ? this.adressePrincipale.creerParEntite
            : listeAudits[index - 1].changeParEntite

        auditAffichage.modifieLe = index === 0
            ? this.adressePrincipale.creerLe
            : listeAudits[index - 1].modifieLe

        auditPrecedent = auditAffichage

        listeAffichage.push(auditAffichage)
      })

      // par design, la liste est affichée à partir du plus récent enregistrement.
      // pour ne pas désordonner la liste finale, dans le cas vraiment weird où la
      // date de création serait plus avancée que la date du premier audit (e.g. immatriculation MMK9098),
      // on shift() le premier élément avant de filter, puis on le repousse à la fin
      let tmpAuditCreationsujet = listeAffichage.shift()
      listeAffichage.sort((a,b) => {
        return new Date(b.modifieLe) - new Date(a.modifieLe)
      });
      listeAffichage.push(tmpAuditCreationsujet)

      return listeAffichage
    },
    formatterAucunAudit(){
      let listeAudits = [];
      let audit = {
        "telephone1": this.adressePrincipale.telephone1,
        "typeTelephone1Afficher": this.adressePrincipale.typeTelephone1Afficher,
        "disponibilite1Afficher": this.adressePrincipale.disponibilite1Afficher,
        "telephone2": this.adressePrincipale.telephone2,
        "typeTelephone2Afficher": this.adressePrincipale.typeTelephone2Afficher,
        "disponibilite2Afficher": this.adressePrincipale.disponibilite2Afficher,
        "telephone3": this.adressePrincipale.telephone3,
        "typeTelephone3Afficher": this.adressePrincipale.typeTelephone3Afficher,
        "disponibilite3Afficher": this.adressePrincipale.disponibilite3Afficher,
      }
      let auditAffichage = {}
      this.AUDIT_FIELDS.forEach(field => {
        auditAffichage[field] = { texte: audit[field], isModifie: false, }
      })

      auditAffichage.changeParEntite = audit.changeParEntite

      listeAudits.push(auditAffichage);
      return listeAudits;
    },
    haveTelephonesChanged(dernierAudit) {
      const fields = [
        "telephone1", "telephone2", "telephone3",
        "typeTelephone1", "typeTelephone2", "typeTelephone3",
        "disponibilite1", "disponibilite2", "disponibilite3"
      ];

      return fields.some(field => this.adressePrincipale[field] !== dernierAudit[field]);
    }
  },
};
</script>